// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * What an uploaded simulation asset holds.
 */
export enum SimulationAssetKind {
  /**
   * A Wireshark capture (.pcap or .pcapng).
   */
  CAPTURE = 0,

  /**
   * A KONE `<opcdomain>` OPC UA server configuration (XML).
   */
  OPCUA_DOMAIN = 1,
}
